export type PlayerGender = 'female' | 'male';
export type PlayerInterest = 'strategy' | 'outdoors' | 'craft' | 'arts';

export interface PlayerAvatar {
  id: string; name: string; title: string; image: string; gender: PlayerGender; interest: PlayerInterest; build: 'light' | 'solid';
}

export const PLAYER_AVATARS: PlayerAvatar[] = [
  { id: 'female-wanderer', name: '青禾', title: '雲路旅人', image: '/player/female-wanderer.webp', gender: 'female', interest: 'arts', build: 'light' },
  { id: 'female-scholar', name: '墨蘭', title: '藏卷棋士', image: '/player/female-scholar.webp', gender: 'female', interest: 'strategy', build: 'light' },
  { id: 'female-explorer', name: '凌青', title: '踏嶺遊俠', image: '/player/female-explorer.webp', gender: 'female', interest: 'outdoors', build: 'light' },
  { id: 'female-artisan', name: '暖玉', title: '百工巧手', image: '/player/female-artisan.webp', gender: 'female', interest: 'craft', build: 'solid' },
  { id: 'male-scholar', name: '硯舟', title: '藏卷棋士', image: '/player/male-scholar.webp', gender: 'male', interest: 'strategy', build: 'light' },
  { id: 'male-explorer', name: '行川', title: '踏嶺遊俠', image: '/player/male-explorer.webp', gender: 'male', interest: 'outdoors', build: 'light' },
  { id: 'male-artisan', name: '木衡', title: '百工巧手', image: '/player/male-artisan.webp', gender: 'male', interest: 'craft', build: 'solid' },
  { id: 'male-artist', name: '竹音', title: '風雅旅人', image: '/player/male-artist.webp', gender: 'male', interest: 'arts', build: 'light' },
];

export function matchPlayerAvatar(gender: PlayerGender, interest: PlayerInterest, build: 'light' | 'solid'): PlayerAvatar {
  const genderPool = PLAYER_AVATARS.filter((avatar) => avatar.gender === gender);
  return genderPool.find((avatar) => avatar.interest === interest && avatar.build === build)
    ?? genderPool.find((avatar) => avatar.interest === interest)
    ?? genderPool.find((avatar) => avatar.build === build)
    ?? genderPool[0]!;
}
